import React from "react";

import "./styles.less";
import { useTranslation } from "react-i18next";
import { AuthingButton } from "../../components/AuthingButton";
import { DownRcode } from "../../components/DownRcode";

export const SecurityBanner = () => {
  const { t } = useTranslation();
  return (
    <section>
      <div className="security-banner-warp">
        <div className="security-banner">
          <div className="banner-bg">
            <img
              src={`//files.authing.co/authing-website/banner-security.svg`}
              alt="authing security banner"
            />
          </div>
          <div className="banner-content">
            <div className="banner-title">
              {t("security.Authing安全与合规")}
            </div>
            <div className="banner-subtitle">
              {t("security.security-banner-subtitle")}
            </div>
            <DownRcode url="solution-security-1.png">
              <AuthingButton
                mode="light"
                // onClick={() => {
                //   window.open(
                //     "https://www.authing.cn/authingform?fromTag=安全与合规&download=https://host.huiju.cool/file/77c2b3c22f5d49d1941a247cb9186454"
                //   );
                // }}
              >
                {t("common.down-solution")}
              </AuthingButton>
            </DownRcode>
          </div>
        </div>
      </div>
    </section>
  );
};
